// Messages between an embedded form and the page embedding it. The receipt in
// `avocado-form-submitted` proves the submission to TMT's success page, so it
// is only ever posted to an origin the server listed for this form — never '*'.

export const MESSAGE_READY = 'avocado-form-ready';
export const MESSAGE_SUBMITTED = 'avocado-form-submitted';

const toOrigin = (url) => {
    try {
        return new URL(url).origin;
    } catch (e) {
        return null;
    }
};

// The embedding page's origin, but only when it is one of `allowedOrigins`.
// `ancestorOrigins` (Chrome, Safari) names the parent directly; elsewhere the
// referrer is the best signal, since an iframe's referrer is its embedding page.
export const resolveParentOrigin = (allowedOrigins, { ancestorOrigins, referrer } = {}) => {
    const allowed = (allowedOrigins ?? []).map(toOrigin).filter(Boolean);
    if (allowed.length === 0) return null;

    const candidates = [
        ancestorOrigins && ancestorOrigins.length > 0 ? ancestorOrigins[0] : null,
        referrer ? toOrigin(referrer) : null,
    ].filter(Boolean);

    return candidates.find((origin) => allowed.includes(origin)) ?? null;
};

export const buildSubmittedMessage = (formId, submission) => ({
    type: MESSAGE_SUBMITTED,
    formId,
    submissionId: submission?.id ?? null,
    receipt: submission?.receipt ?? null,
});

// Posts the submission receipt to the embedding TMT page. Returns whether it
// was handed over, so the form knows to wait for the parent to move on.
export const postSubmittedToParent = (form, submission, win = window) => {
    if (!form?.embed?.linked || win.parent === win || !submission?.receipt) return false;

    const origin = resolveParentOrigin(form.embed.parentOrigins, {
        ancestorOrigins: win.location?.ancestorOrigins,
        referrer: win.document?.referrer,
    });
    if (!origin) return false;

    win.parent.postMessage(buildSubmittedMessage(form.id, submission), origin);
    return true;
};
